export default {
  namespaced: true,
  state: {
    session: null
  },

  getters: {
    session: state => state.session,
    department: state => state.session.department
  },

  mutations: {
    SET_SESSION: (state, payload = null) => {
      if ((payload.user != null) && (!payload.user.gender)) {
        payload.user.gender = {
          id: null,
          title: null
        }
      }

      state.session = payload;
    },
    USER_UPDATE: (state, payload = null) => {
      state.session.user = payload
    },
    SET_DEPARTMENT: (state, payload = null) => {
      state.department = payload
    },
    FAKE_SESSION: (state) => {
      state.session = {
        "id": 27,
        "stage": 40,
        "user": {
          "id": 15,
          "age": 29,
          "name": "\u0411\u0440\u043e\u043d\u0438\u0441\u043b\u0430\u0432",
          "phone": "79518881640",
          "gender": {"id": 1, "title": "\u041c\u0443\u0436\u0447\u0438\u043d\u0430"}
        },
        "department": {
          "id": 4,
          "title": "\u0426\u0435\u043d\u0442\u0440 \u043d\u0430 \u0442\u0430\u043d\u043a\u0438\u0441\u0442\u043e\u0432"
        }
      }
    },
    CLEAR_SESSION: (state) => {
      state.session = null
    },
    EDIT_STAGE: (state, payload = null) => {
      state.session.stage = payload
    }
  },

  actions: {
    SEND_CODE: async function ({commit}, payload) {
      let {data} = await this.$api.session.sendCode(payload);
      commit('SET_SESSION', data);
    },
    OPEN: async function ({commit}, payload) {
      let {data} = await this.$api.session.open(this.state.session.session.id, payload);
      commit('SET_SESSION', data);
    },
    CLOSE: async function ({commit}, payload) {
      await this.$api.session.close(this.state.session.session.id, payload)
      commit('CLEAR_SESSION')
    },
    SET_STAGE: function ({commit}, payload) {
      commit('EDIT_STAGE', payload)
    },
    EDIT_DEPARTMENT: ({commit}, payload) => {
      commit('SET_DEPARTMENT', payload);
    },
    DEMO: function ({commit}, payload) {

      let data = payload
      if (!data.user.gender) {
        data.user.gender = {
          id: 999,
          title: '-'
        }
      }
      commit('SET_SESSION', data);
    },
    CURRENT: async function ({commit}) {
      let {data} = await this.$api.session.current()
      if (Object.keys(data).length) commit('SET_SESSION', data);
    }


  },
};
